import { motion } from "framer-motion";
import { ShieldCheck, Timer, Award, Truck } from "lucide-react";

const points = [
  { Icon: Truck, title: "Deutschlandweit", text: "Kein Termin, kein Anfahrtsweg. Du sendest dein iPhone bequem von überall in Deutschland ein." },
  { Icon: Timer, title: "1–3 Tage gesamt", text: "Dein Gerät wird meist nach einem Werktag repariert und direkt zurückgesendet – in der Regel 1–3 Tage." },
  { Icon: ShieldCheck, title: "6 Monate Garantie", text: "Auf Display-Reparaturen mit Original-OLED – schriftlich und verbindlich." },
  { Icon: Award, title: "Premium-Ersatzteile", text: "Wir verbauen ausschließlich Komponenten in Original-Qualität. Keine Billigware." },
];

export default function WhyUs() {
  return (
    <section id="warum" data-testid="whyus" className="relative z-10 bg-[#050505] py-24 lg:py-36 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#888] mb-4">
              Warum G-Repair
            </p>
            <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
              Fokus schlägt Fläche.
            </h2>
            <p className="text-[#999] mt-6 max-w-md leading-relaxed">
              Wir reparieren keine Waschmaschinen und keine Laptops. Nur iPhones.
              Diese Spezialisierung ist dein Vorteil: schneller, präziser und mit echter
              Erfahrung.
            </p>
          </div>

          <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4">
            {points.map((p, i) => (
              <motion.div
                key={p.title}
                data-testid={`whyus-${i}`}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: (i % 2) * 0.1 }}
                className="rounded-3xl border border-white/10 bg-[#0a0a0a] p-8 hover:border-white/25 transition-colors duration-500"
              >
                <p.Icon size={26} className="text-white mb-6" />
                <h3 className="font-display text-2xl text-white">{p.title}</h3>
                <p className="text-[#999] text-sm mt-2 leading-relaxed">{p.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
